import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "osc-panel" }
const _hoisted_2 = {
  key: 0,
  class: "osc-body"
}
const _hoisted_3 = { class: "osc-detail-header" }
const _hoisted_4 = { class: "osc-detail-title" }
const _hoisted_5 = { class: "osc-detail-meta" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "osc-items" }
const _hoisted_8 = { class: "osc-item-top" }
const _hoisted_9 = { class: "osc-item-title" }
const _hoisted_10 = {
  key: 0,
  class: "osc-item-desc"
}
const _hoisted_11 = {
  key: 0,
  class: "osc-item-evidence"
}
const _hoisted_12 = {
  key: 0,
  class: "osc-evidence-line"
}
const _hoisted_13 = {
  key: 1,
  class: "osc-evidence-line"
}
const _hoisted_14 = {
  key: 2,
  class: "osc-evidence-meta"
}
const _hoisted_15 = {
  key: 1,
  class: "osc-body"
}
const _hoisted_16 = { class: "osc-filters" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "osc-loading"
}
const _hoisted_19 = {
  key: 1,
  class: "osc-empty"
}
const _hoisted_20 = {
  key: 2,
  class: "osc-list"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "osc-os-card-top" }
const _hoisted_23 = { class: "osc-item-title" }
const _hoisted_24 = { class: "osc-item-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "osc-header" }, [
      _createElementVNode("h2", { class: "osc-title" }, "Consultar Ordens de Serviço"),
      _createElementVNode("p", { class: "osc-subtitle" }, "Busque por número, título ou projeto. Clique numa OS para ver o detalhe e exportar em PDF.")
    ], -1)),
    (_ctx.selected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "osc-back",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected = null))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
            ], -1),
            _createTextVNode(" Voltar ", -1)
          ]))]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, "OS" + _toDisplayString(_ctx.selected.osNumber) + " — " + _toDisplayString(_ctx.selected.title), 1),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.selected.projectName) + " · " + _toDisplayString(_ctx.selected.responsaveis.join(', ')) + " ", 1),
                (_ctx.selected.dueDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · prazo " + _toDisplayString(_ctx.formatDate(_ctx.selected.dueDate)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["osc-priority-badge", 'p-' + _ctx.selected.priority])
                }, _toDisplayString(_ctx.priorityLabel(_ctx.selected.priority)), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(["osc-status-badge", 's-' + _ctx.selected.status])
                }, _toDisplayString(_ctx.statusLabel(_ctx.selected.status)), 3)
              ])
            ]),
            _createElementVNode("button", {
              class: "osc-btn osc-btn-primary",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportPdf(_ctx.selected)))
            }, "Exportar PDF")
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "osc-item-card"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
                    (item.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["osc-status-badge", 's-' + item.status])
                  }, _toDisplayString(_ctx.itemStatusLabel(item.status)), 3)
                ]),
                (item.textResponse || item.checkResponse || item.completedByName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (item.textResponse)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.textResponse), 1))
                        : _createCommentVNode("", true),
                      (item.checkResponse)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "✓ Marcado como feito"))
                        : _createCommentVNode("", true),
                      (item.completedByName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Concluído por " + _toDisplayString(item.completedByName) + " em " + _toDisplayString(_ctx.formatDateTime(item.completedAt)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              class: "osc-input osc-search",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
              placeholder: "Buscar por número (ex.: OS3), título ou projeto...",
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "osc-select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.projectId) = $event)),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "Todos os projetos", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: p.id,
                  value: p.id
                }, _toDisplayString(p.name), 9, _hoisted_17))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.filters.projectId]
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Carregando..."))
            : (_ctx.orders.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Nenhuma OS encontrada."))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (os) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: os.id,
                      class: "osc-os-card",
                      type: "button",
                      onClick: ($event: any) => (_ctx.openDetail(os))
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, "OS" + _toDisplayString(os.osNumber) + " — " + _toDisplayString(os.title), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["osc-status-badge", 's-' + os.status])
                        }, _toDisplayString(_ctx.statusLabel(os.status)), 3)
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(os.projectName) + " · " + _toDisplayString(os.responsaveis.join(', ')), 1)
                    ], 8, _hoisted_21))
                  }), 128))
                ]))
        ]))
  ]))
}